// @ts-nocheck
import standardStyle from 'assets/css/standardStyle'
import { FadedAnimatedDiv, LottieWrapper, PageHeader } from 'components'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import CreateEmailTemplateSlider from './CreateEmailTemplate'
import { createOrUpdateEmailTemplates, deleteEmailTemplates, getEmailTemplates } from 'store/actions/emailTemplateActions'
import DeleteModal from 'components/DeleteModal'
import tableLoading from 'assets/lottieJsons/tableLoading.json'

const Card = ({ title, value }) => (
  <div className=''>
    <div
      className='bg-white rounded'
      style={{ fontFamily: standardStyle.fonts.sfpro }}
    >
      <div className='flex flex-col space-y-2 p-6'>
        <div className='text-xs text-softBlack_70 font-medium uppercase'>
          {title}
        </div>
        <div className='text-xl text-softBlack font-bold'>{value}</div>
      </div>
    </div>
  </div>
)

const EmailCampaignBuilderPage = () => {
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(true)
  const [templates, setTemplates] = useState([])
  const [isSliderOpen, setIsSliderOpen] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [deleteTemplateId, setDeleteTemplateId] = useState()
  const [newTemplate] = useState({
    name: '',
    unlayerProjectId: 174034,
    unlayerTemplateId: Date.now(),
    unlayerTemplateName: '',
    unlayerConfig: {}
  })

  const getAllTemplates = () => {
    getEmailTemplates().then((response) => {
      setTemplates(response)
      setIsLoading(false)
    }).catch((error) => console.log(error))
  }

  useEffect(() => {
    getAllTemplates()
  }, [])

  const createTemplate = (name) => {
    setIsSliderOpen(false)
    createOrUpdateEmailTemplates({
      ...newTemplate,
      name: name,
      unlayerTemplateName: name
    })
      .then((res) => {
        history.push(
          `/admin/email-builder/edit/${res.id}`
        )
      })
      .catch((error) => console.log(error))
  }

  const deleteTemplate = () => {
    setIsLoading(true)
    deleteEmailTemplates(deleteTemplateId)
      .then(() => getAllTemplates())
      .catch((error) => console.log(error))
    setShowDeleteModal(false)
  }

  const RightContent = () => (
    <button
      className='flex justify-center items-center font-bold p-3 bg-volt rounded cursor-pointer w-48'
      onClick={() => setIsSliderOpen(true)}
    >
      Create Template
    </button>
  )

  return (
    <>
      <PageHeader
        title='Email Campaigns Builder'
        rightContent={<RightContent />}
      />
      <div className='px-4 sm:px-6 lg:px-8 mt-4'>
        <div className='grid grid-cols-6 gap-4 pt-4'>
          <Card title={'Templates'} value={templates.length} />
        </div>
        <div className='mt-8 flow-root bg-white rounded px-6'>
          <div className='-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8'>
            <div className='inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8'>
              {
                isLoading
                  ? <>
                    <FadedAnimatedDiv
                      key='loadingTable'
                      className='w-full h-full flex items-center justify-center my-10 flex-col'
                    >
                      <LottieWrapper
                        animation={tableLoading}
                        loop
                        className='h-16 w-16'
                      />
                      <span className='text-base'>loading...</span>
                    </FadedAnimatedDiv>
                  </>
                  : templates.length
                    ? <table className='min-w-full divide-y divide-gray-300'>
                      <thead>
                        <tr>
                          <th
                            scope='col'
                            className='py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0'
                          >
                            Name
                          </th>
                        </tr>
                      </thead>
                      <tbody className='divide-y divide-gray-200'>
                        {templates?.map((template) => (
                          <tr key={template.id}>
                            <td className='whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-900 sm:pl-0'>
                              {template.unlayerTemplateName}
                            </td>
                            <td className='whitespace-nowrap py-4 text-sm flex justify-end gap-3 text-gray-900 sm:pl-0'>
                              <button
                                className='text-softBlack text-center text-base font-medium py-2 px-6 rounded flex items-center border border-black'
                                onClick={() =>
                                  history.push(
                                    `/admin/email-builder/edit/${template.id}`
                                  )
                                }
                              >
                                View / Edit
                              </button>
                              <button
                                className='text-softBlack text-center text-base font-medium py-2 px-6 rounded flex items-center bg-volt'
                                onClick={() => {
                                  setDeleteTemplateId(template.id)
                                  setShowDeleteModal(true)
                                }}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    : <h1 className='text-center text-xl py-6 mb-0'>Templates not found.</h1>
              }
            </div>
          </div>
        </div>
      </div>
      <DeleteModal
        title='Are you sure?'
        description='Do you want to delete?'
        confirmButtonTitle='Delete Template'
        cancelButtonTitle='Cancel'
        isOpen={showDeleteModal}
        setIsOpen={setShowDeleteModal}
        onConfirm={deleteTemplate}
      />
      <CreateEmailTemplateSlider
        onClose={() => setIsSliderOpen(false)}
        onSubmit={(name) => createTemplate(name)}
        open={isSliderOpen}
      />
    </>
  )
}

export default EmailCampaignBuilderPage
